import React from "react";
import { map } from "lodash";
import styles from "./ItineraryPlanning.module.scss";
import { Img } from "../ImgV2/Img";
export function ItineraryDaily(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.itineraryPlanningBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, props.daily_plan_title), /*#__PURE__*/React.createElement("div", {
    className: styles.itineraryPlanningList
  }, /*#__PURE__*/React.createElement(ItineraryPlan, {
    plans: props.daily_plan
  })));
}
function ItineraryPlan(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, map(props.plans, function (plan) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.itineraryPlanningItem,
      key: plan.event_summary
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.logo
    }, /*#__PURE__*/React.createElement(Img, {
      className: "itineraryPlanLogoImg",
      imgKey: plan.event_image
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.time
    }, plan.event_start_time, " - ", plan.event_end_time), /*#__PURE__*/React.createElement("div", {
      className: styles.description
    }, plan.event_summary));
  }));
}